export default {
  name: 'GcRadio',
  data() {
    return {
      className: 'gc__radio',
    };
  },
  computed: {
    horizontalDisplay() {
      return (this.horizontal) ? `${this.className}--horizontal` : '';
    },
    uniqueId() {
      return `${this.className}--${Math.round(Math.random() * 100000)}`;
    },
  },
  props: {
    radioBtns: {
      type: Array,
      default: () => [],
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: null,
    },
  },
  methods: {
    // IE11/Edge does not emit Input on Radio inputs so for v-model to work we need
    // to emit an Input and Change event on change.
    emitValues(eventValue) {
      this.$emit('input', eventValue);
      this.$emit('change', eventValue);
    },
  },
};
